import { render, staticRenderFns } from "./deliveryPlanList.vue?vue&type=template&id=94f8e990&scoped=true"
import script from "./deliveryPlanList.vue?vue&type=script&lang=js"
export * from "./deliveryPlanList.vue?vue&type=script&lang=js"
import style0 from "./deliveryPlanList.vue?vue&type=style&index=0&id=94f8e990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94f8e990",
  null
  
)

export default component.exports